/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutiveAssistantInvitationRequest
 */
export interface ExecutiveAssistantInvitationRequest {
    /**
     * 
     * @type {number}
     * @memberof ExecutiveAssistantInvitationRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ExecutiveAssistantInvitationRequest
     */
    assistantEmail: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExecutiveAssistantInvitationRequest
     */
    accepted?: boolean;
}

/**
 * Check if a given object implements the ExecutiveAssistantInvitationRequest interface.
 */
export function instanceOfExecutiveAssistantInvitationRequest(value: object): value is ExecutiveAssistantInvitationRequest {
    if (!('assistantEmail' in value) || value['assistantEmail'] === undefined) return false;
    return true;
}

export function ExecutiveAssistantInvitationRequestFromJSON(json: any): ExecutiveAssistantInvitationRequest {
    return ExecutiveAssistantInvitationRequestFromJSONTyped(json, false);
}

export function ExecutiveAssistantInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutiveAssistantInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'assistantEmail': json['assistant_email'],
        'accepted': json['accepted'] == null ? undefined : json['accepted'],
    };
}

export function ExecutiveAssistantInvitationRequestToJSON(json: any): ExecutiveAssistantInvitationRequest {
    return ExecutiveAssistantInvitationRequestToJSONTyped(json, false);
}

export function ExecutiveAssistantInvitationRequestToJSONTyped(value?: ExecutiveAssistantInvitationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assistant_email': value['assistantEmail'],
        'accepted': value['accepted'],
    };
}

